export default {
    props: {
        messagesStartLabel: {
            type: String,
            kComposite: 'messages.startLabel'
        }, 
        messagesEndLabel: {
            type: String,
            kComposite: 'messages.endLabel'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateRangePicker/Messages.js